import { Button, Typography } from '@mui/material'
import { useState } from 'react'
import { IoInformationCircle } from 'react-icons/io5'
import { governmentSourcesUpdate } from '../../lib/entities'
import { Dialog } from '../atoms'
import { titleCaseString } from '../../lib/utils'
import { makeStyles } from 'tss-react/mui'
import { colors } from '@hazadapt-git/public-core-base'

export const GovernmentSourcesUpdateModal = () => {
    const { classes } = useLocalStyles()
    const [open, setOpen] = useState<boolean>(false)
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    return (
        <>
            <Button onClick={handleOpen} className={classes.button}>
                <IoInformationCircle size={'1.5rem'} />
                <Typography>{governmentSourcesUpdate.headline}</Typography>
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                title={titleCaseString(governmentSourcesUpdate.headline)}
                content={governmentSourcesUpdate.content}
                ctas={[
                    <Button
                        key={'dismiss'}
                        onClick={handleClose}
                        variant="contained"
                    >
                        Dismiss
                    </Button>,
                ]}
            />
        </>
    )
}

const useLocalStyles = makeStyles()({
    button: {
        textDecoration: 'underline',
        display: 'grid',
        gridTemplateColumns: '1.5rem auto',
        gap: '.5rem',
        color: colors.grays.THUNDERCLOUD,
        '&:hover': {
            textDecoration: 'underline',
        },
        textAlign: 'start',
    },
})
